interface Props {
    className?: string;
}

export function StayInContactIcon({ className }: Props) {
    return <img className={className} src="/icon_dark_no_bg.svg" alt="StayInContact Icon" />;
}
